import React from "react";
import withRouter from "../components/common/withRouter";
import { Toaster } from "react-hot-toast";
import { LogoIcon } from "@/components/common/Logo";
import { useSearchParams } from "react-router-dom";

export const AuthHeader = (props: { title: string, subtitle: string }) => {
  const { title, subtitle } = props;

  return (
    <div className="flex flex-col items-center pb-4 text-center">
      <LogoIcon />
      <p className="text-xl font-medium mt-5">
        {title}
      </p>
      <p className="text-small text-default-500">
        {subtitle}
      </p>
    </div>
  )
}

const NonAuthLayout = (props: any) => {
  const [searchParams] = useSearchParams();
  const isGhostMode = searchParams.get("ghost") === "true";

  return (
    <React.Fragment>
      <div className={`relative flex min-h-dvh flex-col ${isGhostMode ? 'bg-white' : 'bg-background bg-lime-50 bg-radial'} ${isGhostMode ? '' : 'pt-4 md:pt-16'} ${!isGhostMode ? 'auth-bg' : ''}`}>
        <div className={`flex items-center ${isGhostMode ? 'justify-start' : 'justify-center'} ${isGhostMode ? 'p-0' : 'p-4'}`}>
          <div className={`flex h-full w-full flex-col items-center justify-center ${isGhostMode ? 'max-w-sm' : ''}`}>
            <div className={`flex w-full max-w-sm flex-col gap-4 rounded-large ${isGhostMode ? 'bg-white' : 'bg-content1'} ${isGhostMode ? 'px-6 pb-8 pt-4' : 'px-8 pb-10 pt-6'} ${!isGhostMode ? 'shadow-small' : ''}`}>
              {props.children}
            </div>
          </div>
        </div>
      </div>
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
          },
        }}
      />
    </React.Fragment>
  );
};

export default withRouter(NonAuthLayout);
